/**
 * Blog Filters JavaScript
 * Handles blog filter functionality
 */

// console.log('Blog filters JavaScript loaded');

// Add blog filter functionality here
document.addEventListener('DOMContentLoaded', function() {
    // Blog filter search functionality
    // const searchInputs = document.querySelectorAll('.blog-search-input');
    
    // searchInputs.forEach(function(input) {
    //     input.addEventListener('input', function() {
    //         console.log('Blog search input changed:', this.value);
    //         // Add search filtering logic here
    //     });
    // });
    
    // Blog filter accordion functionality
    // Target both blog categories (.npi-accordion-categories) and event types (.npi-accordion-event-types)
    const desktopCategoryAccordionButton = document.querySelectorAll('.blog-sidebar--desktop-filters .npi-accordion-categories button.npi-accordion-item__toggle, .blog-sidebar--desktop-filters .npi-accordion-event-types button.npi-accordion-item__toggle');

    desktopCategoryAccordionButton.forEach(function(accordionButton) {
        // console.log('1004am desktop Blog filter accordion button found:', accordionButton);
        // Additional blog-specific accordion functionality can be added here
        accordionButton.setAttribute('aria-expanded', 'true');
    });

    const desktopCategoryAccordionContent = document.querySelectorAll('.blog-sidebar--desktop-filters .npi-accordion-categories .npi-accordion-item__content, .blog-sidebar--desktop-filters .npi-accordion-event-types .npi-accordion-item__content');

    desktopCategoryAccordionContent.forEach(function(accordionContent) {
        // console.log('running category panel function');
        // console.log('desktop Blog filter accordion content found:', accordionContent);
        accordionContent.style.display = 'block';
        accordionContent.style.height = 'auto';
    });

});